import React from "react";
import { Panel } from "./FrequencyChart";
import { heatColor } from "./Ball";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "./ui/tooltip";

export const Heatmap = ({ frequency }) => (
  <Panel title="Full Number Heatmap" testid="heatmap"
    right={<Legend />}>
    <TooltipProvider delayDuration={80}>
      <div className="flex flex-wrap gap-1.5">
        {frequency.map((f) => (
          <Tooltip key={f.number}>
            <TooltipTrigger asChild>
              <div
                data-testid={`heat-cell-${f.number}`}
                className="w-8 h-8 rounded-md flex items-center justify-center text-[10px] font-mono font-bold cursor-default transition-transform duration-150 hover:scale-110"
                style={{
                  backgroundColor: heatColor(f.heat),
                  color: f.heat >= 0.25 ? "#09090b" : "#a1a1aa",
                }}
              >
                {f.number}
              </div>
            </TooltipTrigger>
            <TooltipContent className="bg-zinc-950 border-zinc-700 font-mono text-xs">
              #{f.number} · {f.count}× ({f.pct}%)
            </TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  </Panel>
);

const Legend = () => (
  <div className="hidden sm:flex items-center gap-2 text-[10px] text-zinc-500 font-mono">
    <span>COLD</span>
    <div className="flex gap-0.5">
      {["#27272a", "#0891b2", "#3B82F6", "#FBBF24", "#FF9500", "#FF3B30"].map((c) => (
        <div key={c} className="w-3.5 h-3.5 rounded-sm" style={{ backgroundColor: c }} />
      ))}
    </div>
    <span>HOT</span>
  </div>
);
